import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function useDarkMode() {
  const [dark, setDark] = useState(() => {
    try {
      const stored = localStorage.getItem('tm-theme');
      if (stored) return stored === 'dark';
    } catch { /* ignore */ }
    // Prerendering runs this initialiser in Node, where `window` does not exist.
    // Default to light so the static HTML is deterministic; the effect below
    // re-syncs to the real preference the moment we hydrate.
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    try { localStorage.setItem('tm-theme', dark ? 'dark' : 'light'); } catch { /* ignore */ }
  }, [dark]);

  return [dark, setDark];
}

export default function AppHeader() {
  const [dark, setDark] = useDarkMode();

  return (
    <header className="app-header" role="banner">
      <div className="app-header__inner">
        <Link to="/" className="app-header__logo" aria-label="TalkMuch home">
          <span className="app-header__logo-text">TalkMuch</span>
        </Link>
        <a
          href="https://www.linkedin.com/in/v%C3%A1clav-jandek-a852b915b/"
          className="app-header__social"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Václav Jandek on LinkedIn"
          title="Václav Jandek on LinkedIn"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true" focusable="false">
            <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.37-1.85c3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13zm1.78 13.02H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.22.79 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
          </svg>
        </a>
        <nav className="app-header__nav" aria-label="Main navigation">
          <NavLink
            to="/podcasts"
            state={{ resetHome: true }}
            className={({ isActive }) =>
              `app-header__nav-link${isActive ? ' app-header__nav-link--active' : ''}`
            }
          >
            Podcasts
          </NavLink>
          <NavLink
            to="/leaderboard"
            className={({ isActive }) =>
              `app-header__nav-link${isActive ? ' app-header__nav-link--active' : ''}`
            }
          >
            Leaderboard
          </NavLink>
          <button
            type="button"
            className="app-header__theme-toggle"
            onClick={() => setDark(d => !d)}
            aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
            title={dark ? 'Light mode' : 'Dark mode'}
          >
            {dark ? '☀' : '☾'}
          </button>
        </nav>
      </div>
    </header>
  );
}
